export default __webpack_public_path__ + "static/media/cross_icon_white.b00be816.svg";